export const colors = {
  white: '#fff',
  loginBackgroundColor: '#E5E5E5',
  purple: '#585CEA',
  red: '#F12D40',
  black: '#2A2A2A',
  lightGray: ' #d7d7d7',
  gray: '#A3A8AE',
  darkGray: '#7B828A',
  green: '#019E47',
  yellow: '#E8D000',
  orange: '#FF5F1F',
  blue: '#0569FF',
  lightBlue: '#0094E8',
  shadow: 'rgba(0, 0, 0, 0.12)',
  lightPurple: '#C9CAF8',
  light70: 'rgba(255, 255, 255, 0.7)',
};
